<div *ngIf="payroll && startData">
  <manual-payroll-header
    [payrollStartData]="startData"
    [showConfirm]="payroll.EmployeePays.length ? true : false"
    (onConfirmButton)="navigateToPreview()"
    (onCancelButton)="navigateToPayrollHub()"></manual-payroll-header>

  <div class="content-wrapper mt-5">
    <h6 class="pb-2">
      <strong>
        Enter a name below to calculate a pay. Calculated pays will be saved for the next payroll
        run.
      </strong>
    </h6>
    <div id="manual-pay-employee-search" class="ng-autocomplete">
      <div class="input-group">
        <ng-autocomplete
          [data]="data"
          [searchKeyword]="keyword"
          placeholder="Search Employees / Contractors"
          (selected)="selectEvent($event)"
          (inputChanged)="onChangeSearch($event)"
          [(ngModel)]="searchValue"
          [itemTemplate]="query && query.length >= 2 ? itemTemplate : null"
          [notFoundTemplate]="query && query.length >= 2 ? notFoundTemplate : null"
          data-testid="person-search">
        </ng-autocomplete>
        <ng-template #itemTemplate let-item>
          <a [innerHTML]="item.Value"></a>
        </ng-template>
        <ng-template #notFoundTemplate let-notFound>
          <small>No records found...</small>
        </ng-template>
        <div class="input-group-append">
          <img src="assets/icons/search.svg" class="search-icon" />
        </div>
      </div>
    </div>
    <div><small>*You can calculate multiple pays for the same person.</small></div>
    <div *ngIf="showRequestWarning">
      <span
        ><div class="d-inline-block relay-icon relay-icon--warning mx-2"></div>
        At least one person in the table below has a pending address change request.<a
          [routerLink]="baseUrl + '/' + clientCode + '/approvals'"
          >View Requests</a
        ></span
      >
    </div>
    <div
      id="manual-payroll-list"
      *ngIf="manualPaylines && manualPaylines.length"
      class="drop-shadow">
      <table class="table">
        <thead>
          <tr>
            <th>
              <lib-checkbox
                [ngModel]="selectAll"
                (ngModelChange)="selectAllChanged($event)"
                [id]="'chk_all'"
                [size]="checkSizes.Small"
                label="Select (All)"></lib-checkbox>
            </th>
            <th></th>
            <th></th>
            <th>Person</th>
            <th>Check Id</th>
            <th class="text-center">Net Amount</th>
            <th class="text-center">Details</th>
            <th class="text-center">Remove</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let m of currentPage">
            <td>
              <lib-checkbox
                [ngModel]="m.Selected"
                (ngModelChange)="checkChanged($event, m)"
                [id]="'chk_' + m.Payline.PaylineId"
                [size]="checkSizes.Small"></lib-checkbox>
            </td>
            <td>
              <i
                *ngIf="m.Payline.Errors != null && m.Payline.Errors.length > 0"
                class="fas fa-exclamation-triangle"
                [ngbTooltip]="warningTooltip"
                style="border-radius: 30px; padding: 8px; background-color: #ffc113; color: #fff">
              </i>
              <ng-template #warningTooltip>
                <span class="d-block" *ngFor="let warning of m.Payline.Errors">{{
                  warning.Message
                }}</span>
              </ng-template>
            </td>
            <td><i class="far fa-3x fa-user-circle"></i></td>
            <td>
              {{ m.Name }}
              <div>
                <small>{{ m.MultiPaylineDisplay }}</small>
              </div>
            </td>
            <td>{{ checkNumberDisplay(m.Payline.OverrideCheckNumber) }}</td>
            <td class="text-end">{{ m.Payline.NetAmountPaid | currency }}</td>
            <td class="text-center">
              <button
                class="btn btn-tertiary px-4 py-2"
                data-testid="payline-edit"
                (click)="open(m)">
                {{ m.Payline.CanEdit ? 'Edit' : 'View' }}
              </button>
            </td>
            <td class="text-center">
              <button class="btn btn-link" data-testid="payline-delete" (click)="delete(m)">
                <i class="far fa-2x fa-trash-alt"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <lib-client-side-pagination
          [collection]="manualPaylines"
          (currentPage)="pageChanged($event)"></lib-client-side-pagination>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <button
          class="btn btn-primary"
          (click)="reportGenerate()"
          [disabled]="selectedLines.length === 0">
          Print Selected
        </button>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="showPaylineDetails">
  <payline-detail-editor
    [args]="paylineDetailArgs"
    [payroll]="payroll"
    [employeePay]="selEmployeePay"
    [startData]="startData"
    [earningConfigs]="earningConfigs"
    [deductionConfigs]="deductionConfigs"
    [taxConfigs]="taxConfigs"
    (onCloseDetails)="closePaylineDetails($event)">
  </payline-detail-editor>
</ng-container>
